<!-- help-support.component.html -->
<div class="flex flex-col flex-auto min-w-0">

<!-- <mat-toolbar style="background-color:#fff;" class="py-10">
    <div class="grid grid-cols-2 mt-0 w-full">
            <div class="pt-9">
              
                <span class="page-title font-bold">Help Documentation</span>
                <div class="mat-subtitle" style="margin-top: -9px;">All the product documentation in one location.</div>
            </div>
            <div>
                <div class="grid grid-cols-3 gap-4">
                    <div class="col-span-1"></div>
                    <div class="col-span-10 hd-search m-8">
                        <mat-form-field>
                            <input matInput  [autocomplete]="'off'" [placeholder]="'Search for help'">
                        </mat-form-field>
                    </div>
                    <div class="col-span-1"></div>
                </div>
            </div>
    </div>
</mat-toolbar> -->
<div class=" hdemblttl" >
<ds-cstm-header [dsHeader]="dsHeader"
            (onGetFilterActionEvntEmtr)="onGetFilterActionEvntEmtr($event)"></ds-cstm-header>
</div>
            <div class="shwmblttl">
              Help Documentation
              </div>

            

  <!-- help-tabs.component.html -->

<div class="helpTabs p-6">
    <mat-tab-group class="page-header-tab" headerPosition="left" [(selectedIndex)]="selectedTabIndex" (selectedTabChange)="selectChnageTab($event);">
      <!-- <mat-tab label="Release Notes">
        <app-release-note *ngIf="relsntes"></app-release-note>
      </mat-tab> -->
      <mat-tab label="Help Documents">
        <app-help-documents *ngIf="helpdoc"></app-help-documents>
      </mat-tab>
      <mat-tab label="Help Videos">
        <app-help-vedios *ngIf="helpvedio"></app-help-vedios>
      </mat-tab>
      <mat-tab label="FAQs">
        <app-help-faq *ngIf="helpfaq"></app-help-faq>
      </mat-tab>
      <!-- <mat-tab label="Support">
      </mat-tab> -->
    </mat-tab-group>
    <app-tckts-asgnd *ngIf="support"></app-tckts-asgnd>


  </div>
</div>
  
  